import React, { useEffect, useRef, useState } from "react"
import { graphql } from 'gatsby'
import styled from "styled-components"
import Img from "gatsby-image"
import { CSSTransition } from "react-transition-group"

import { _raf, truncateString } from "../utils/helpers"
import CtaBanner from "../components/Common/CtaBanner";

import SEO from "@ifp/gatsby-theme-shared/src/components/SEO/seo"

// import SubscribeNewsletter from "../components/Sections/SubscribeNewsletter"
import CtaCategories from "../components/Sections/CtaCategories"

const ArticleHero = styled.section`
    position: relative;
    @media screen and (min-width: 768px) {
        .container__row {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            & > div {
                width: calc((100% - 40px) / 2);
                &:first-child {
                    margin-right: 40px;
                }
            }
        }
    }
    @supports (grid-gap: 0) {
        @media screen and (min-width: 768px) {
            .container__row {
                display: -ms-grid;
                display: grid;
                grid-gap: 40px;
                -ms-grid-columns: 1fr 40px 1fr;
                grid-template-columns: 1fr 1fr;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                & > div {
                    width: 100%;
                    &:first-child {
                        margin-right: 0;
                    }
                }
            }
        }
    }
`

const Article = styled.div`
    @keyframes ghost-line {
        from {
            width: 100%;
        }
        to {
            width: 0%;
        }
    }
    .ghost-container {
        position: relative;
        max-width: 420px;
        margin-left: auto;
        margin-right: auto;
        @media (min-width: 768px) {
            max-width: 720px;
        }
    }
    .thing {
        position: absolute;
        top: 8px;
        left: -160px;
        height: 8px;
        background: var(--black);
        border-radius: 9999px;
        overflow: hidden;
        width: calc((100vw - 740px) / 2);
        transform: translateX(-100%);
        transform-origin: right center;
        &:after {
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            width: 100%;
            background: white;
            z-index: 10;
            animation: ghost-line 1s var(--cubic-bezier) forwards;
        }
    }
`

export default ({ data }) => {
    const guide = data.wordpressWpGuides
    const { title, content, featured_media, slug } = guide

    const widgetTriggerEl = useRef()
    const [showWidget, setShowWidget] = useState(false)

    useEffect(() => {
        window._waEvents.push("pageView", {
            page: {
                section: "guide",
                name: `post:${truncateString(slug, 50)}`,
                language: "english",
            },
            sysEnv: {
                siteGroup: "rc",
            },
        })

        window.addEventListener("scroll", () => {
            _raf()(() => {
                window.pageYOffset > 3000
                    ? setShowWidget(true)
                    : setShowWidget(false)
            })
        })
    }, [slug])

    return (
        <>
            <SEO {...guide} categories={[{ slug: "guide" }]} article pageType="resources"/>
            <div className="ehi-header--spacer"></div>
            <ArticleHero>
                <div className="container container--grid">
                    <div className="container__row">
                        <div
                            className="overflow-hidden rounded"
                            style={{
                                opacity: 0,
                                animation:
                                    "fadeFromRightSubtle 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                            }}
                        >
                            {featured_media && featured_media.localFile && (
                                <Img
                                    sizes={
                                        featured_media.localFile.childImageSharp
                                            .sizes
                                    }
                                />
                            )}
                        </div>
                        <div
                            className="content pt-3 pt-sm-4 pl-md-4 pl-lg-5"
                            style={{
                                opacity: 0,
                                animation:
                                    "fadeFromLeftSubtle 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                            }}
                        >
                            <h1
                                className="display-4 mb-xxs"
                                dangerouslySetInnerHTML={{ __html: title }}
                            />
                        </div>
                    </div>
                </div>
            </ArticleHero>
            <Article className="bg-white mb-5">
                <div className="ghost-container" ref={widgetTriggerEl}>
                    <div className="thing" />
                </div>
                <section className="container container--grid pt-0">
                    <div className="container__row">
                        <div
                            ref={widgetTriggerEl}
                            className="wysiwyg pb-xxl"
                            dangerouslySetInnerHTML={{ __html: content }}
                        />
                    </div>
                </section>
            </Article>

            {/* <SubscribeNewsletter fromPage={slug} leadType="ifp" /> */}

            <div className="divider divider-bottom bg-green"></div>
            <CtaCategories />

            <CSSTransition
                in={showWidget}
                timeout={600}
                classNames="slide-up"
                unmountOnExit
            >
                <CtaBanner fromPage={slug} category="Individual and Family" />
            </CSSTransition>
        </>
    )
}

export const query = graphql`
    query($id: Int!) {
        wordpressWpGuides(wordpress_id: { eq: $id }) {
            title
            excerpt
            content
            slug
            date(formatString: "MMMM DD, YYYY")
            modified(formatString: "MMMM DD, YYYY")
            author {
                name
            }
            featured_media {
                source_url
                media_details {
                    width
                    height
                }
                localFile {
                    childImageSharp {
                        sizes(maxWidth: 730) {
                            ...GatsbyImageSharpSizes
                        }
                    }
                }
            }
            yoast_meta {
                yoast_wpseo_metadesc
                yoast_wpseo_title
            }
        }
    }
`
